import { render, staticRenderFns } from "./Oxviewdetails.vue?vue&type=template&id=0a3565de&"
import script from "./Oxviewdetails.vue?vue&type=script&lang=js&"
export * from "./Oxviewdetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports